export const translations = {
  de: {
    appName: "FalkeDeck",
    tagline: "Angebote, durchdacht.",
    // Navigation
    dashboard: "Dashboard",
    quotes: "Angebote",
    invoices: "Rechnungen",
    pdfBundle: "PDF-Sammlung",
    positions: "Katalog",
    categories: "Kategorien",
    customers: "Kunden",
    users: "Nutzer",
    aufmasse: "Aufmaße",
    settings: "Einstellungen",
    logout: "Abmelden",
    // Theme
    lightMode: "Hell",
    darkMode: "Dunkel",
    // Auth
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    company: "Firma",
    noAccount: "Noch kein Konto?",
    haveAccount: "Bereits registriert?",
    signIn: "Einloggen",
    signUp: "Konto erstellen",
    loginTitle: "Willkommen zurück",
    loginSubtitle: "Melde dich an, um deine Angebote und Rechnungen zu verwalten.",
    forgotPassword: "Passwort vergessen?",
    forgotTitle: "Passwort zurücksetzen",
    forgotSubtitle: "Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen.",
    forgotSubmit: "Reset-Link senden",
    forgotSent: "Falls ein Konto zu dieser E-Mail existiert, wurde ein Reset-Link versendet.",
    backToLogin: "Zurück zur Anmeldung",
    resetTitle: "Neues Passwort setzen",
    resetSubtitle: "Wähle ein neues Passwort für dein Konto.",
    resetSubmit: "Passwort speichern",
    resetSuccess: "Passwort geändert. Du bist jetzt angemeldet.",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordMismatch: "Passwörter stimmen nicht überein.",
    registerTitle: "Konto erstellen",
    registerSubtitle: "Starte kostenlos mit deiner Angebots- und Rechnungsverwaltung.",
    // Common
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    create: "Anlegen",
    search: "Suchen…",
    actions: "Aktionen",
    description: "Beschreibung",
    total: "Gesamt",
    subtotal: "Zwischensumme",
    vat: "MwSt.",
    vatRate: "MwSt.-Satz",
    discount: "Rabatt",
    quantity: "Menge",
    unit: "Einheit",
    unitPrice: "Einzelpreis",
    status: "Status",
    title: "Projekttitel",
    customer: "Kunde",
    number: "Nummer",
    createdAt: "Erstellt",
    validUntil: "Gültig bis",
    invoiceDate: "Rechnungsdatum",
    dueDate: "Fällig am",
    notes: "Notizen",
    downloadPdf: "PDF herunterladen",
    downloadZugferd: "ZUGFeRD-PDF",
    downloadXrechnung: "XRechnung XML",
    convertToInvoice: "In Rechnung umwandeln",
    sourceQuote: "Quell-Angebot",
    sourceAufmass: "Aufmaß",
    purchaseOrderNumber: "Bestellnummer",
    newProforma: "Proforma Rechnung",
    stornoInvoice: "Stornorechnung",
    createStorno: "Storno erstellen",
    reissueFromStorno: "Korrektur-Rechnung",
    locked: "Eingefroren",
    invoiceLocked: "Diese Rechnung ist eingefroren. Für Änderungen bitte eine Storno-Rechnung erstellen.",
    aufmassLocked: "Dieses Aufmaß ist eingefroren. Für Änderungen bitte ein Storno-Aufmaß erstellen.",
    // Dashboard
    overview: "Übersicht",
    totalQuotes: "Angebote gesamt",
    totalInvoices: "Rechnungen",
    acceptedRevenue: "Umsatz (angenommen)",
    openVolume: "Offenes Volumen",
    pipeline: "Pipeline",
    recent: "Zuletzt erstellt",
    noQuotes: "Noch keine Angebote vorhanden.",
    createFirst: "Erstes Angebot anlegen",
    // Categories
    categoryName: "Kategoriename",
    newCategory: "Neue Kategorie",
    editCategory: "Kategorie bearbeiten",
    noCategories: "Noch keine Kategorien. Lege eine Oberkategorie an, um Positionen zu strukturieren.",
    // Positions
    positionName: "Positionsname",
    newPosition: "Neue Position",
    editPosition: "Position bearbeiten",
    category: "Kategorie",
    uncategorized: "Ohne Kategorie",
    tierPricing: "Staffelpreise",
    minQty: "Ab Menge",
    addTier: "Staffel hinzufügen",
    noPositions: "Noch keine Positionen. Lege deine erste Positionsvorlage an.",
    // Customers
    newCustomer: "Neuer Kunde",
    editCustomer: "Kunde bearbeiten",
    phone: "Telefon",
    address: "Adresse",
    taxId: "USt-IdNr.",
    noCustomers: "Noch keine Kunden erfasst.",
    // Quotes / Invoices
    newQuote: "Neues Angebot",
    editQuote: "Angebot bearbeiten",
    newInvoice: "Neue Rechnung",
    editInvoice: "Rechnung bearbeiten",
    noInvoices: "Noch keine Rechnungen vorhanden.",
    addLine: "Position hinzufügen",
    pickPosition: "Aus Katalog wählen",
    emptyLine: "Freie Position",
    draft: "Entwurf",
    sent: "Versendet",
    accepted: "Angenommen",
    rejected: "Abgelehnt",
    issued: "Ausgestellt",
    paid: "Bezahlt",
    overdue: "Überfällig",
    cancelled: "Storniert",
    selectCustomer: "Kunde wählen",
    noCustomer: "Kein Kunde",
    lineTotal: "Positionssumme",
    details: "Details",
    // Messages
    confirmDelete: "Wirklich löschen?",
    saved: "Gespeichert",
    errorSaving: "Fehler beim Speichern",
    mustSaveFirst: "Bitte zuerst speichern.",
    // Bulk / confirm / archive
    selectAll: "Alle auswählen",
    copy: "Kopieren",
    restore: "Wiederherstellen",
    archive: "Archiv",
    archived: "Archiviert",
    daysRemaining: "Tage verbleibend",
    confirmDeleteTitle: "Wirklich löschen?",
    confirmDeleteMany: "Möchtest du {n} Einträge wirklich löschen?",
    confirmInvoiceDeleteDesc: "Die Rechnung wird in den Papierkorb verschoben und nach 30 Tagen endgültig gelöscht. Wiederherstellen möglich.",
    confirmHardDeleteDesc: "Dies kann nicht rückgängig gemacht werden.",
    deleteButton: "Löschen",
    filters: "Filter",
    sortBy: "Sortierung",
    sortNumber: "Nummer",
    sortName: "Name",
    sortPriceAsc: "Preis ↑",
    sortPriceDesc: "Preis ↓",
    priceMin: "Preis min",
    priceMax: "Preis max",
    resetFilters: "Filter zurücksetzen",
    allCategories: "Alle Kategorien",
    allUnits: "Alle Einheiten",
    positionNumber: "Positionsnr.",
    categoryNumber: "Kat.-Nr.",
    tabDetails: "Details",
    tabTiers: "Staffelpreise",
    emptyArchive: "Keine archivierten Rechnungen.",
    moveToTrash: "In Papierkorb verschieben",
    permanentDelete: "Endgültig löschen",
  },
  en: {
    appName: "FalkeDeck",
    tagline: "Quotes, well-crafted.",
    dashboard: "Dashboard",
    quotes: "Quotes",
    invoices: "Invoices",
    pdfBundle: "PDF bundle",
    positions: "Catalog",
    categories: "Categories",
    customers: "Customers",
    users: "Users",
    aufmasse: "Measurements",
    settings: "Settings",
    logout: "Sign out",
    lightMode: "Light",
    darkMode: "Dark",
    login: "Sign in",
    register: "Sign up",
    email: "Email",
    password: "Password",
    name: "Name",
    company: "Company",
    noAccount: "No account yet?",
    haveAccount: "Already registered?",
    signIn: "Log in",
    signUp: "Create account",
    loginTitle: "Welcome back",
    loginSubtitle: "Sign in to manage your quotes and invoices.",
    forgotPassword: "Forgot password?",
    forgotTitle: "Reset your password",
    forgotSubtitle: "Enter your email address and we'll send you a reset link.",
    forgotSubmit: "Send reset link",
    forgotSent: "If an account exists for this email, a reset link has been sent.",
    backToLogin: "Back to login",
    resetTitle: "Set a new password",
    resetSubtitle: "Choose a new password for your account.",
    resetSubmit: "Save password",
    resetSuccess: "Password updated. You're signed in.",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match.",
    registerTitle: "Create account",
    registerSubtitle: "Start managing quotes and invoices for free.",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    search: "Search…",
    actions: "Actions",
    description: "Description",
    total: "Total",
    subtotal: "Subtotal",
    vat: "VAT",
    vatRate: "VAT rate",
    discount: "Discount",
    quantity: "Qty",
    unit: "Unit",
    unitPrice: "Unit price",
    status: "Status",
    title: "Project title",
    customer: "Customer",
    number: "Number",
    createdAt: "Created",
    validUntil: "Valid until",
    invoiceDate: "Invoice date",
    dueDate: "Due date",
    notes: "Notes",
    downloadPdf: "Download PDF",
    downloadZugferd: "ZUGFeRD PDF",
    downloadXrechnung: "XRechnung XML",
    convertToInvoice: "Convert to invoice",
    sourceQuote: "Source quote",
    sourceAufmass: "Measurement",
    purchaseOrderNumber: "PO number",
    newProforma: "Proforma invoice",
    stornoInvoice: "Cancellation invoice",
    createStorno: "Create cancellation",
    reissueFromStorno: "Correction invoice",
    locked: "Locked",
    invoiceLocked: "This invoice is locked. To change it, please create a cancellation invoice.",
    aufmassLocked: "This Aufmaß is locked. To change it, please create a cancellation.",
    overview: "Overview",
    totalQuotes: "Total quotes",
    totalInvoices: "Invoices",
    acceptedRevenue: "Revenue (accepted)",
    openVolume: "Open volume",
    pipeline: "Pipeline",
    recent: "Recently created",
    noQuotes: "No quotes yet.",
    createFirst: "Create your first quote",
    categoryName: "Category name",
    newCategory: "New category",
    editCategory: "Edit category",
    noCategories: "No categories yet. Create one to organize your positions.",
    positionName: "Position name",
    newPosition: "New position",
    editPosition: "Edit position",
    category: "Category",
    uncategorized: "Uncategorized",
    tierPricing: "Tier pricing",
    minQty: "Min qty",
    addTier: "Add tier",
    noPositions: "No positions yet. Create your first catalog item.",
    newCustomer: "New customer",
    editCustomer: "Edit customer",
    phone: "Phone",
    address: "Address",
    taxId: "Tax ID",
    noCustomers: "No customers yet.",
    newQuote: "New quote",
    editQuote: "Edit quote",
    newInvoice: "New invoice",
    editInvoice: "Edit invoice",
    noInvoices: "No invoices yet.",
    addLine: "Add line",
    pickPosition: "Pick from catalog",
    emptyLine: "Custom line",
    draft: "Draft",
    sent: "Sent",
    accepted: "Accepted",
    rejected: "Rejected",
    issued: "Issued",
    paid: "Paid",
    overdue: "Overdue",
    cancelled: "Cancelled",
    selectCustomer: "Select customer",
    noCustomer: "No customer",
    lineTotal: "Line total",
    details: "Details",
    confirmDelete: "Really delete?",
    saved: "Saved",
    errorSaving: "Error while saving",
    mustSaveFirst: "Please save first.",
    selectAll: "Select all",
    copy: "Copy",
    restore: "Restore",
    archive: "Archive",
    archived: "Archived",
    daysRemaining: "days remaining",
    confirmDeleteTitle: "Really delete?",
    confirmDeleteMany: "Delete {n} items?",
    confirmInvoiceDeleteDesc: "The invoice will be moved to trash and permanently deleted after 30 days. Can be restored.",
    confirmHardDeleteDesc: "This cannot be undone.",
    deleteButton: "Delete",
    filters: "Filters",
    sortBy: "Sort",
    sortNumber: "Number",
    sortName: "Name",
    sortPriceAsc: "Price ↑",
    sortPriceDesc: "Price ↓",
    priceMin: "Price min",
    priceMax: "Price max",
    resetFilters: "Reset filters",
    allCategories: "All categories",
    allUnits: "All units",
    positionNumber: "Pos. no.",
    categoryNumber: "Cat. no.",
    tabDetails: "Details",
    tabTiers: "Tier pricing",
    emptyArchive: "No archived invoices.",
    moveToTrash: "Move to trash",
    permanentDelete: "Delete permanently",
  },
};
